module.exports = __webpack_public_path__ + "static/media/calendar-circle.244d7b0d.svg";